import { create } from 'zustand'

export const useInvoicesStore = create(set => ({
  dateExpiryStart: null,
  setDateExpiryStart: dateExpiryStart => set(() => ({ dateExpiryStart })),
  dateExpiryEnd: null,
  setDateExpiryEnd: dateExpiryEnd => set(() => ({ dateExpiryEnd })),
  isLoading: false,
  setIsLoading: loading => set(() => ({ isLoading: loading })),
  invoicesData: [],
  setInvoicesData: invoicesData => set(() => ({ invoicesData })),
  barsValue: 0,
  setBarsValue: value => set(() => ({ barsValue: value })),
  barsPData: [],
  setBarsPData: data => set(() => ({ barsPData: data })),
  barsXLabels: [],
  setBarsXLabels: labels => set(() => ({ barsXLabels: labels })),
  barsPDataByDays: [],
  setBarsPDataByDays: data => set(() => ({ barsPDataByDays: data })),
  barsXLabelsByDays: [],
  setBarsXLabelsByDays: labels => set(() => ({ barsXLabelsByDays: labels })),
  walletExpiredBalanceData: [],
  setWalletExpiredBalanceData: data =>
    set(() => ({ walletExpiredBalanceData: data })),
  setRechargeBalance: rechargeBalance => set(() => ({ rechargeBalance })),
  rechargeBalance: 0,
  setRechargeCount: rechargeCount => set(() => ({ rechargeCount })),
  rechargeCount: 0,
  resetStore: () =>
    set(() => ({
      dateExpiryStart: null,
      dateExpiryEnd: null,
      isLoading: false,
      invoicesData: [],
      barsValue: 0,
      barsPData: [],
      barsXLabels: [],
      barsPDataByDays: [],
      barsXLabelsByDays: [],
      walletExpiredBalanceData: [],
      rechargeBalance: 0,
      rechargeCount: 0,
    })),
}))
